import axios from 'axios';


axios.defaults.baseURL = 'https://hair-services.herokuapp.com/api/v1/';

export default axios;